import {Divider, Input, Radio} from "antd";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";

export const MBThirdSection = () => {
    const content = [
        {
            title: "Quản lý đăng tuyển",
            description: "Với thư viện chuẩn của hơn 1000+ mô tả công việc gợi ý cho nhà tuyển dụng với các ngành nghề và vị trí khác nhau"
        },
        {
            title: "Quản lý ứng viên",
            description: "Với công cụ quản lý tích hợp, báo cáo trực quan, dễ sử dụng và theo dõi kho hồ sơ ứng viên theo từng vị trí đăng tuyển"
        },
        {
            title: "Quảng cáo đa nền tảng",
            description: "Với cơ chế kết hợp nguồn tiếp cận thông qua các kênh truyền thông mạng xã hội giúp tăng cơ hội tiếp cận ứng viên tiềm năng"
        }
    ]
    return (
        <div className={"lg:hidden block"}>
            <h2 className="text-3xl font-bold text-center text-white">Phiên bản 2025 giúp đăng tuyển nhanh chóng và hiệu quả hơn</h2>
            <Divider/>
            <Swiper
                modules={[Autoplay]}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                slidesPerView={1}
                className={"w-auto"}>
                {content.map((item, index) => (
                    <SwiperSlide className={"bg-gradient-to-bl from-green-100 to-purple-300 rounded-md"} key={index}>
                        <div className={"flex flex-col p-4 max-h-fit rounded-lg text-center gap-4"}>
                            <h2 className={"text-2xl font-bold"}>{item.title}</h2>
                            <p>{item.description}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className={"justify-center mx-auto"}>
                <h2 className={"text-3xl font-bold text-center text-black mt-12"}>Hãy để chúng tôi hỗ trợ bạn</h2>
                <p className={"text-center text-black mt-4"}>Chúng tôi luôn sẵn sàng hỗ trợ tư vấn và giải đáp mọi thắc mắc của bạn về tuyển dụng nhân sự qua Vieclamsanxuat</p>
            </div>
            <div className={"justify-center bg-gradient-to-br from-green-100 to-purple-300 gap-3 mx-auto p-4 border shadow-md rounded-lg mt-4"}>
                <h2 className={"text-xl font-bold text-center text-black"}>Đăng ký nhận bản tin</h2>
                <div className={"grid grid-cols-1 gap-2"}>
                    <div>
                        <label className={"text-black font-semibold"}>Tên công ty</label>
                        <Input placeholder={"Nhập tên công ty"}/>
                    </div>
                    <div>
                        <label className={"text-black font-semibold"}>Địa chỉ email</label>
                        <Input placeholder={"Nhập email của bạn"}/>
                    </div>
                    <div>
                        <label className={"text-black font-semibold"}>Số điện thoại</label>
                        <Input placeholder={"Nhập số điện thoại của bạn"}/>
                    </div>
                    <div>
                        <label className={"text-black font-semibold"}>Quy mô công ty</label>
                        <Radio.Group>
                            <Radio value={0}>Dưới 50 nhân viên</Radio>
                            <Radio value={1}>Từ 50 đến 100 nhân viên</Radio>
                            <Radio value={2}>Trên 100 nhân viên</Radio>
                        </Radio.Group>
                    </div>
                    <button
                        className="mt-4 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-700 hover:to-cyan-700 text-white font-bold py-3 px-8 rounded-full transition duration-300"
                    >
                        Yêu cầu tư vấn
                    </button>
                </div>
            </div>
        </div>
    )
}